export default __webpack_public_path__ + "fonts/Liens-White.svg";